import React, { useMemo } from "react";
import CommonUserAvatar from "../../CommonUserAvatar";

const UserProfileCard = ({ user, size = "medium", disabled = false, iconOnly = false }) => {
  const name = useMemo(() => {
    return user?.firstName || user?.lastName || user?.fullName || user?.email;
  }, [user]);

  return (
      <div
          className={`d-flex flex-row align-items-center ${iconOnly ? "" : "gap-3 pe-3"} ${
              disabled ? "hs-cursor-not-allowed" : "cursor-pointer"
          }`}
      >
          <div>
              <CommonUserAvatar name={name} icon={user?.avatar} size={size === "small" ? 23 : 40} />
          </div>
          {iconOnly ? null : (
              <div>
                  {name ? (
                      <div className="hs-fs-14 fs-fw-500 hs-fw-500" data-cy="user-profile-name">
                          {name}
                      </div>
                  ) : null}
                  {user?.email ? (
                      <div
                          className="hs-fs-12 hs-fw-500 hs-color-light-grey-2 user-profile-card-email"
                          data-email={user?.email}
                          data-cy={`user-email-${user?.email}`}
                      >
                          {user?.email}
                      </div>
                  ) : null}
              </div>
          )}
      </div>
  );
};

export default UserProfileCard;
